export const PromoItemStatuses = {
  Locked: 'locked',
  Active: 'active',
  Valid: 'valid',
  Claimed: 'claimed',
  Missed: 'missed',
} as const;

export type PromoItemStatus =
  typeof PromoItemStatuses[keyof typeof PromoItemStatuses];

export const PromoItemTypes = {
  Tool: 'tool',
  Credit: 'credit',
  Asset: 'asset',
} as const;

export type PromoItemType = typeof PromoItemTypes[keyof typeof PromoItemTypes];

export const PromoStatuses = {
  Active: 'active',
} as const;

export interface PromoTheme {
  primaryColor?: string;
  bannerImageUrl?: string;
  iconUrl?: string;
}

export interface Promo {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  status: string;
  totalGifts: number;
  giftAvailabilitySeconds: number;
  description: string;
  theme?: PromoTheme;
  userParticipatedAt: string | null;
}

export interface PromoItem {
  id: string;
  promoId: string;
  periodIndex: number;
  itemName: string;
  itemType: PromoItemType;
  creditAmount: number | null;
  toolIds: string[] | null;
  assetId: string | null;
  toolDeeplink: string | null;
  toolIconUrl: string | null;
  itemPreview: string | null;
  description: string | null;
}

export interface PromoItemEntry {
  status: PromoItemStatus;
  claimedAt: string | null;
  item: PromoItem;
}

export interface PromoItemsResponse {
  items: PromoItemEntry[];
  restartRequired: boolean;
  skippedAtPeriodIndex: number | null;
  journeyCompleted: boolean;
}

export interface PromoJourney {
  promoId: string;
  userParticipatedAt: string;
  items: PromoItemEntry[];
}

export const StreakSheetModes = {
  NotJoined: 'notJoined',
  Normal: 'normal',
  Waiting: 'waiting',
  Restart: 'restart',
  Completed: 'completed',
} as const;

export type StreakSheetMode =
  typeof StreakSheetModes[keyof typeof StreakSheetModes];

export interface StreakDay {
  dayNumber: number;
  status: PromoItemStatus;
  creditAmount: number | null;
  rewardName: string;
}

export interface StreakViewState {
  isVisible: boolean;
  days: StreakDay[];
  currentDayNumber: number;
  isFinalDay: boolean;
  canClaim: boolean;
  isWaiting: boolean;
  heroDay: StreakDay | null;
  sheetMode: StreakSheetMode;
  nextClaimAt: string | null;
  prizeName: string | null;
}

export interface ResolveDisplayDaysParams {
  streakDays: StreakDay[];
  sheetMode: StreakSheetMode;
}
